const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "GLAVA-TIJELO1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M127.89,167.4c-2.8,12.1-25,20.9-21.9,20.9,48.6-.8,61.2,66.6,67.7,77.9,6,10.5,43.9-24.9,55-40.7,9.4-13.4.4-45.7-7.6-59.1-5-8.3-15-18.4-25.5-19.3C177.39,147.1,150.59,162.3,127.89,167.4Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,173.3c-2.1,10.4-19,18-16.7,18,37.1-.7,46.7,57.4,51.6,67.1,4.6,9,33.4-21,37.7-36.1,7.6-26.1,7.6-38-2.3-50.9-3.8-7.1-10.8-14.8-18.7-15.6C167.1,149,148.2,165.1,132.8,173.3Z",
    style: {
      fill: "#d9d9d9",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,190.4c-1.7,9.5-15.4,16.4-13.5,16.3,30-.7,37.8,52.1,41.8,60.9,3.7,8.2,27.1-19.5,33.9-31.9,5.8-10.5.3-35.8-4.7-46.2-3.1-6.5-9.3-14.4-15.7-15.1C160.8,174.5,144.2,186.4,130.2,190.4Z",
    style: {
      fill: "#e6e6e6",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.6,174.33c6.1,6.5,26.4-8.7,37.4-14.5,9.5-5,29-9,37-5.1,16.7,9.6,22.8,30.6,23.4,40.2.7,10.8,2.2,27.6-12.1,42.3-6.9,7-31.7,17.5-42.9,32.6-2.3,3.11-3.5,5.09-4.06,7.17-2.37,8.81-2.92,19.69.66,22.73,4.71,4,20-1.77,61.4-36-8.4-7.1,29.8-14,24.9-49.9-1.2-9.2-2.3-29.3,4.6-27.5,15.7,4.2,21.5-24.4-1.7-24.4-2.2,1.4,23.8-19.8-1.8-29.3-.9-25.9-24.2-5.7-33.3,4.8-8.5,9.8-26.2,7.7-39.6,6.2-7.5-.8-24.8,2.5-32.1,6.1C140.5,153.93,122.6,169,127.6,174.33Z",
    style: {
      fill: "#cc200a",
      stroke: "#000",
      strokeLinecap: "square",
      strokeLinejoin: "bevel",
      strokeWidth: "1.414199948310852px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4,186.63c13.7-5.5,17-10.8,19.7-17.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 2.884999990463257,
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.5,131.43c-2.2,18.3-24.1,22.8-27.1,21.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 5.7133002281188965,
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.4,166.73a13.5,13.5,0,0,0,9.4-.7c3.5-1.3,6-3.8,7.2-4.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeMiterlimit: 5.7133002281188965,
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.4,124.43c-3.1-.2-5.5-.1-8.6,14.2-1.7,7.8-16.3,10.7-15.1,12.2.8,1,5.7-.7,8.4-1.4C247.7,147.23,257.1,128.63,250.4,124.43Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.8,139.43c-2.6-.2-4.6,0-7.1,13.1-1.4,7.1-13.5,9.8-12.5,11.3.6,1,4.8-.6,7-1.3C259.6,160.43,267.3,143.23,261.8,139.43Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.4,177.33c-.5,2.8-1,4.9-12.4,5.4-6.2.2-11.3,12.8-12.2,11.5-.6-.9,1.6-5,2.7-7.3C252.5,175.93,268.5,170.63,270.4,177.33Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.6,152.43c-28.4,12.9-22.1,28.6,3.7,6.8,1.4-2,28.6-9.2,30.2-8.1C177.3,145.63,158.9,150.43,154.6,152.43Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.4,206.23c-2.9-.1-7,13.1-12.2,22.5-3.7,6.7-7.4,9.5-14.3,12.7-14.9,7-19.3,22.8-11.2,21.6,10.3-1.6,37.8-22.9,39.6-34C246.9,224.43,254.7,206.63,244.4,206.23Z",
    style: {
      fillRule: "evenodd",
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.2,131.83c.4-5,2.8-9.2,6.6-7.3,1.2.9,2.2,3.5-.7,9.7-2.5,5.2-6.9,9-8.5,9.8C224.2,150.63,239.5,141.53,240.2,131.83Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHead);
export default __webpack_public_path__ + "static/media/head.324890a4844565c5ba4c44ef8a5bd75b.svg";
export { ForwardRef as ReactComponent };